import http from "infra/http";
import { useQuery } from "react-query";
import { RateioItem } from "../typings";

interface UseGetRateiosProps {
  year: string;
  month: string;
}

function useGetRateios({ year, month }: UseGetRateiosProps) {
  return useQuery([`/v1/rateio`], async () => {
    const { data } = await http.get(`/v1/rateio`, {
      params: {
        mes: month,
        ano: year,
      },
    });

    return data as RateioItem[];
  });
}

export default useGetRateios;
